import type {ReactAction} from '@netx/core/bootstrap';
import {faEyeSlash} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartVisibility} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Hide cart assets
 * @param params
 * @returns Action
 */
export const cartActionManageVisibilityHide = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-visibility-hide',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.VISIBILITY_HIDE),
	enableTest: canManageCurrentCartVisibility,
	icon: faEyeSlash,
	get label() {
		return CART_CURRENT_ACTION_LABELS.VISIBILITY_HIDE;
	},
	...params,
});

export default cartActionManageVisibilityHide;
